import Api from "./Api.js";

const resource = "/order-adjustments";

export default {
  list(params) {
    return Api.get(`${resource}`, {
      params: params,
    });
  },
};
